// extracted by mini-css-extract-plugin
module.exports = {"root":"about-1_root__2ld9S","inner":"about-1_inner__17NHl","content":"about-1_content__aB90U","textWrapper":"about-1_textWrapper__13N0u","text":"about-1_text__2L8sJ"};